import React, { useEffect, useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState(null); // Initialize as null
    const [bookedrooms, setbookedrooms] = useState(0);
    const [availablerooms, setavailablerooms] = useState(0);
    const [cleaningrooms, setcleaningrooms] = useState(0);
    const [allrooms, setallrooms] = useState(0);

    const [todayCount, settodayCount] = useState(0);
    const [tommCount, settommCount] = useState(0);
    const [thisMonth, setthisMonth] = useState(0);
    const [nextMonth, setnextMonth] = useState(0);

    const [todayCount1, settodayCount1] = useState(0);
    const [tommCount1, settommCount1] = useState(0);
    const [thisMonth1, setthisMonth1] = useState(0);
    const [nextMonth1, setnextMonth1] = useState(0);


    // Use useCallback to memoize fetchData1, preventing unnecessary re-creations
    const fetchData1 = useCallback(async () => {
        try {
            if (!userData) return; // Only run if userData is set

            const today = new Date().toISOString().split('T')[0];
            const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
            const firstDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');
            const firstDayOfNextMonth = moment().add(1, 'months').startOf('month').format('YYYY-MM-DD');
            const lastDayOfNextMonth = moment().add(1, 'months').endOf('month').format('YYYY-MM-DD');

            // Creating queries in advance
            const websiteBookingsCollection = collection(db, 'websitebookings');
            const advanceBookingsCollection = collection(db, 'advancebookings');
            const roomsCollection = collection(db, 'roomdetails');

            const queries = [
                query(roomsCollection), // 1: all rooms
                query(roomsCollection, where('status', '==', 'Booked')), // 2: booked rooms
                query(roomsCollection, where('status', '==', 'Available')), // 3: available rooms
                query(roomsCollection, where('status', '==', 'Cleaning')), // 4: cleaning rooms

                // Website Bookings (Status Paid)
                query(websiteBookingsCollection, where('checkindate', '==', today), where('status', '==', 'Paid')), // 5: today's WB
                query(websiteBookingsCollection, where('checkindate', '==', tomorrow), where('status', '==', 'Paid')), // 6: tomorrow's WB
                query(websiteBookingsCollection, where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')), // 7: this month's WB
                query(websiteBookingsCollection, where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')), // 8: next month's WB
                
                // Advance Bookings (Status Paid)
                query(advanceBookingsCollection, where('checkindate', '==', today), where('status', '==', 'Paid')), // 9: today's AB
                query(advanceBookingsCollection, where('checkindate', '==', tomorrow), where('status', '==', 'Paid')), // 10: tomorrow's AB
                query(advanceBookingsCollection, where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')), // 11: this month's AB
                query(advanceBookingsCollection, where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')) // 12: next month's AB
            ];

            // Using getCountFromServer is often more efficient than getDocs for just counting
            // Note: Since you were already using getDocs, I'll stick to it for minimal changes, 
            // but know getCountFromServer is better for large datasets.

            // Fetching all data concurrently
            const snapshots = await Promise.all(queries.map(q => getDocs(q)));

            // Set states after all data has been fetched
            setallrooms(snapshots[0].size);
            setbookedrooms(snapshots[1].size);
            setavailablerooms(snapshots[2].size);
            setcleaningrooms(snapshots[3].size);
            settodayCount(snapshots[4].size);
            settommCount(snapshots[5].size);
            setthisMonth(snapshots[6].size);
            setnextMonth(snapshots[7].size);
            settodayCount1(snapshots[8].size);
            settommCount1(snapshots[9].size);
            setthisMonth1(snapshots[10].size);
            setnextMonth1(snapshots[11].size);

        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
            console.error(error.message);
        }
    }, [userData, Toast]); // Include dependencies, especially Toast if it changes (though usually it doesn't)


    // CRITICAL FIX: Auth listener should only run once, and the data fetch should trigger when userData is set.
    useEffect(() => {
        // auth.onAuthStateChanged returns the unsubscribe function for cleanup
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });

        // Cleanup the auth listener on component unmount
        return () => unsubscribe();
    }, []); // Empty dependency array means this runs ONLY ONCE

    // Run data fetch whenever userData changes (from null to user object)
    useEffect(() => {
        if (userData) {
            fetchData1();
        }
    }, [userData, fetchData1]); // Re-run when userData or fetchData1 changes


    // --- Render ---

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <button className="btn btn-secondary" >|| Dashboard ||</button><br /><br />
                        <div className="row">
                            {/* Today's Bookings - Changed to bg-info */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info"> 
                                    <div className="inner">
                                        <h3>{todayCount + todayCount1}</h3>
                                        <p>Today's Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-calendar-day" />
                                    </div>
                                    <a href="online-bookings/todays" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* Tomorrow's Bookings - Changed to bg-success */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <h3>{tommCount + tommCount1}</h3>
                                        <p>Tomorrow's Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-calendar-alt" />
                                    </div>
                                    <a href="online-bookings/tommorrows" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* This Month Bookings - Changed to bg-warning */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-warning">
                                    <div className="inner">
                                        <h3>{thisMonth + thisMonth1}</h3>
                                        <p>This Month Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-calendar-check" />
                                    </div>
                                    <a href="online-bookings/thismonth" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* Next Month Bookings - Changed to bg-primary */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-primary">
                                    <div className="inner">
                                        <h3>{nextMonth + nextMonth1}</h3>
                                        <p>Next Month Bookings</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-calendar-plus" />
                                    </div>
                                    <a href="online-bookings/nextmonth" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            {/* Live Booked Rooms - Changed to bg-danger */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-danger">
                                    <div className="inner">
                                        <h3>{bookedrooms}</h3>
                                        <p>Live Booked Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-door-closed"></i>
                                    </div>
                                    <a href="live-booking-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* Available Rooms - Changed to bg-teal (reused, but distinct from others) */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-teal">
                                    <div className="inner">
                                        <h3>{availablerooms}</h3>
                                        <p>Available Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-door-open"></i>
                                    </div>
                                    <a href="available-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* Cleaning Rooms - Changed to bg-secondary */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-secondary">
                                    <div className="inner">
                                        <h3>{cleaningrooms}</h3>
                                        <p>Cleaning Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-broom"></i>
                                    </div>
                                    <a href="cleaning-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                            
                            {/* All Rooms - Changed to bg-dark */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-dark">
                                    <div className="inner">
                                        <h3>{allrooms}</h3>
                                        <p>All Rooms</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-hotel"></i>
                                    </div>
                                    <a href="all-rooms" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Dashboard